import bgImg1 from '@/assets/images/login/bg_img_1.png'
import bgImg2 from '@/assets/images/login/bg_img_2.png'
import bgImg3 from '@/assets/images/login/bg_img_3.png'
import bgImg4 from '@/assets/images/login/bg_img_4.png'
import { useRef, useState } from 'react'

export const DecorativeImages = () => {
  const [transform3d, setTransform3d] = useState(
    'perspective(800px) translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg)'
  )
  const imgRef = useRef<HTMLImageElement>(null)

  const handleMouseMove = (e: React.MouseEvent<HTMLImageElement>) => {
    if (!imgRef.current) return

    const rect = imgRef.current.getBoundingClientRect()
    const x = (e.clientX - rect.left) / rect.width
    const y = (e.clientY - rect.top) / rect.height

    const smoothX = Math.max(0, Math.min(1, x))
    const smoothY = Math.max(0, Math.min(1, y))

    const rotateX = 45 * (0.5 - smoothY)
    const rotateY = -45 * (0.5 - smoothX)

    const translateZ = Math.min(
      100,
      150 * Math.max(Math.abs(smoothX - 0.5), Math.abs(smoothY - 0.5))
    )

    const transform = `perspective(800px) translate3d(0, 0, ${translateZ}px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.05)`
    setTransform3d(transform)
  }

  const handleMouseLeave = () => {
    const transform =
      'perspective(800px) translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg) scale(1)'
    setTransform3d(transform)
  }

  return (
    <>
      <img
        src={bgImg1}
        alt=""
        className="absolute w-[240px] left-[32.13vw] top-[5vh] animate-float-gentle"
      />
      <img
        src={bgImg2}
        alt=""
        className="absolute w-[240px] left-[-2.1vw] top-[84.63vh] animate-glow-pulse"
      />
      <div
        className="absolute w-[180px] left-[40.78vw] top-[70.6vh] [transform-style:preserve-3d]"
        style={{ perspective: '500px' }}
      >
        <img
          ref={imgRef}
          src={bgImg3}
          alt=""
          className="w-full h-full transition-all duration-500 ease-out will-change-transform"
          style={{
            transform: transform3d,
            transformStyle: 'preserve-3d',
          }}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        />
      </div>
      <img
        src={bgImg4}
        alt=""
        className="absolute w-[200px] left-[87vw] top-[82.29vh] animate-glow-pulse [animation-delay:2s]"
      />
    </>
  )
}
